import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyGlobalAlertsSidebar } from '@jira/navigation-apps__sidebar-eoc-global-alerts/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalGroupDetailRoute } from '@jira/router-routes__eoc-group-detail-routes/src/eocGlobalGroupDetailRoute.tsx';
import { resources as groupDetailResources } from '@atlassian/eoc-group-detail/resources';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import type { Route } from '@atlassian/react-resource-router';
import GroupList, { LazyGroupDetail } from './ui/spa/eoc/group-detail/index.tsx';

export const eocGlobalGroupDetailRouteEntry: Route = createEntry(eocGlobalGroupDetailRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: GroupList,

	resources: [
		...getNavigationResources(),
		...groupDetailResources(),
		getConsolidationStateResource(),
		...alertListResources(),
	],

	navigation: {
		menuId: MenuIdHome,
	},

	forPaint: [LazyAtlassianNavigation, LazyGroupDetail, LazyGlobalAlertsSidebar],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
